<template>
    <div class="frame-ve">
        <div class="pt-2 pb-2 px-2">
            <div :class="rowText">
                <div class="text-left">Biển kiểm soát:</div>
                <div :class="textInfo">{{ item.BienKiemSoat }}</div>
            </div>
            <!-- <div :class="rowText">
                <div class="text-left">Thời gian bán:</div>
                <div :class="textInfo">
                    {{ $Helper.Common.formatDateTime(item.ThoiGianVao) }}
                </div>
            </div> -->
            <div :class="rowText">
                <div class="text-left">Tuyến vận chuyển:</div>
                <div :class="textInfo">
                    {{
                        `${item.TenTuyen}${
                            item.MaTuyen ? `(${item.MaTuyen})` : ``
                        }`
                    }}
                </div>
            </div>
            <div :class="rowText">
                <div class="text-left">Giờ xuất bến:</div>
                <div :class="textInfo">
                    {{ $Helper.Common.formatDateTime(item.GioXuatBen) }}
                </div>
            </div>
            <div :class="rowText">
                <div class="text-left">T/gian tiếp nhận:</div>
                <div :class="textInfo">
                    {{ $Helper.Common.formatDateTime(item.ThoiGianTiepNhan) }}
                </div>
            </div>
            <div :class="rowText">
                <div class="text-left">Mã chuyến đi:</div>
                <div :class="textInfo" class="color-primary">
                    {{ `${item.MaChuyenDi}` }}
                </div>
            </div>
            <div :class="rowText">
                <div class="text-left">Mã đặt chỗ:</div>
                <div :class="textInfo" class="color-primary">
                    {{ `${item.MaDatCho}` }}
                </div>
            </div>
        </div>

        <div style="position: absolute; bottom: 8px; right: 8px">
            <DxButton
                icon="mdi mdi-printer-outline"
                type="normal"
                styling-mode="text"
                @click="InVe(item)"
            />
        </div>
    </div>
</template>

<script>
import { DxButton } from "devextreme-vue";
export default {
    components: {
        DxButton,
    },
    props: {
        item: { type: Object, default: () => {} },
    },
    data() {
        return {
            rowText: "row mb-1 align-center ",
            textInfo: "grow font-medium ml-1",
        };
    },
    computed: {
        CauHinhBenXePhatHanhHoaDonDienTu() {
            return this.$store.state.HoaDonDienTu
                .CauHinhBenXePhatHanhHoaDonDienTu;
        },
    },
    methods: {
        async InVe(data) {
            try {
                this.$startLoading;
                return await this.$Events.Print(
                    SP[`Base_Url`],
                    this.$t("urlKhaiBaoVe.LayPhieuInVe"),
                    {
                        DanhSachVe: [data.IdVeTiepNhan],
                    }
                );
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Khai báo vé thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
};
</script>

<style scoped>
.frame-ve {
    box-shadow: 0px 1px 5px #dadce0;
    border: 1px solid #dadce0;
    margin-top: 8px;
    border-radius: 8px;
    padding: unset !important;
}
.text-left {
    margin-right: 8px;
    width: 100px;
    white-space: break-spaces;
}
</style>
